import { Component, Fragment } from 'react';
import { Button, Card, CardHeader, CardBody, CardFooter } from 'reactstrap';
import { Link } from "react-router-dom";
import { connect } from 'react-redux';
import Navbar from '../../Components/Navbar';
import Sidebar from '../../Components/Sidebar';
import ModalDestroy from '../../Components/Destroy';
import ModalResponse from '../../Components/ModalResponse';
import { Table } from '../../Components/Table';
import { getData, deleteData } from "../../servicos/api";
import { setLoaderShow, setResponseModal, setDestroyModal } from '../../reducers/index';

import colunas from './colunasTabelaCliente';

class CategoriaClienteCliente extends Component {
    constructor(props){
        super(props);

        this.state = { 
            categorias_cliente_cliente: [],
        };

        this.getDataCategoriaClienteCliente  = this.getDataCategoriaClienteCliente.bind(this);
        this.destroyCategoriaClienteCliente  = this.destroyCategoriaClienteCliente.bind(this);
        this.loadingShow    = this.loadingShow.bind(this);
    }

    componentDidMount() {
        this.loadingShow(false);
        this.getDataCategoriaClienteCliente();
    }

    // LOADER
    loadingShow(value) {
        let { setLoaderShow } = this.props;
        setLoaderShow(value);
    }

    async getDataCategoriaClienteCliente(){
        this.loadingShow(true);
        var categorias_cliente_cliente = await getData(`/categoria-cliente/cliente/${this.props.location.data.uuid}`, this.props);
        if(categorias_cliente_cliente !== null){
            this.setState({categorias_cliente_cliente});
        }
        this.loadingShow(false);
    }

    async destroyCategoriaClienteCliente(uuid) {
        this.loadingShow(true);
        await deleteData(`/categoria-cliente/cliente/${uuid}`, this.props);
        await this.getDataCategoriaClienteCliente();
        this.loadingShow(false);
    }

    render(){
        let { setResponseModal, enableResponseModal, setDestroyModal, enableDestroyModal } = this.props;
        return (
            <Fragment>
                <div className="container-scroller">
                    <Navbar/>
                    <div className="container-fluid page-body-wrapper">
                        <Sidebar/>
                        <div className="main-panel">
                            <div className="content-wrapper">
                                <div className="row">
                                    <div className="col-lg-12 grid-margin stretch-card">
                                        <Card>
                                            <CardHeader className="bg-maskats text-center">
                                                <h4 className="headerTitle">Clientes da Categoria {this.props.location.data.nome}</h4>
                                            </CardHeader>
                                            <CardBody>
                                                <div>
                                                    <Table
                                                        columns={colunas}
                                                        rows={this.state.categorias_cliente_cliente}
                                                        setDestroyModal={setDestroyModal} 
                                                        enableDestroyModal={enableDestroyModal}
                                                        next_url='categoria-cliente/cliente/formulario'
                                                    />
                                                </div>
                                            </CardBody>
                                            <CardFooter className="text-align-end bg-white">
                                                <Link replace to="/categoria-cliente">
                                                    <Button className="mr-2 text-white btn btn-sm btn-secondary btn-fw bd-rd-8" type="button">
                                                        <i className="fa fa-arrow-left btn-icon-append btn-fs-def"></i>
                                                        <span className="label-button btn-fs-def">Voltar</span>
                                                    </Button>
                                                </Link>
                                                <Link replace
                                                    className='primary'
                                                    to={{
                                                        pathname: '/categoria-cliente/cliente/formulario',
                                                        data: this.props.location.data
                                                    }}>
                                                    <Button className="btn btn-sm btn-success btn-fw bd-rd-8" type="button">
                                                        <i className="fa fa-plus btn-icon-append btn-fs-def"></i>
                                                        <span className="label-button btn-fs-def">Adicionar</span>
                                                    </Button>
                                                </Link>
                                            </CardFooter>
                                        </Card>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <ModalResponse 
                    history={this.props.history} 
                    setResponseModal={setResponseModal} 
                    enableResponseModal={enableResponseModal}
                />

                <ModalDestroy 
                    destroy={this.destroyCategoriaClienteCliente}
                    setDestroyModal={setDestroyModal} 
                    enableDestroyModal={enableDestroyModal}
                />
            </Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {
        enableLoaderShow: state.enableLoaderShow,
        enableResponseModal: state.enableResponseModal,
        enableDestroyModal: state.enableDestroyModal,
    }
};

const mapDispatchToProps = dispatch => ({
    setLoaderShow: enable => dispatch(setLoaderShow(enable)),
    setResponseModal: enable => dispatch(setResponseModal(enable)),
    setDestroyModal: enable => dispatch(setDestroyModal(enable)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CategoriaClienteCliente);